import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from '../../lib/constants';
import {
  Container,
  TextField,
  Typography,
  Grid,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  MenuItem,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  IconButton,
  Box,
  InputLabel,
  Select,
  FormHelperText
} from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import LocalHospital from '@mui/icons-material/LocalHospital';
import SignatureCanvas from "react-signature-canvas";
import { useParams, useNavigate } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import DraftSaveButton from '../../components/DraftSaveButton';
import { DRAFT_KEYS, loadDraft, hasDraft, saveDraft, clearDraft } from '../../utils/draftUtils';
import { useNotification } from '../../contexts/NotificationContext';

import theme from '../../theme/theme.js';
import { Hospital } from "lucide-react";

const Operative = () => {
  const { showNotification } = useNotification();
  const { uhid_no } = useParams(); // Extract the uhid_no from the URL parameters
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [patient, setPatient] = useState(null);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    ip_no: "",
    uhid_no: uhid_no || "",
    diagnosis: "",
    name_of_surgery: "",
    or_no: "",
    wheel_in_time: "",
    wheel_out_time: "",
    anesthesia_start_time: "",
    anesthesia_end_time: "",
    incision_time: "",
    closure_time: "",
    mode_of_transfer_to_ot: "",
    anesthesia_type: "",
    position: "",
    pressure_protection_pad: {
      Head_rest: false,
      Sand_bag: false,
      "Pillow": false,
      "Axillary Roll": false,
      "Shoulder Roll": false,
      "Eye protection": false,
      "Chest Roll": false,
      "Sling": false,
      "Boot": false,
      "Stirrups": false,
      "Leg holder": false,
      "L Arm padded, tucked & secured": false,
      "R Arm padded, tucked & secured": false,
    },
    pressure_protection_pad_other: "",
    skin_preparation: "",
    skin_preparation_other: "",
    monopolar_pad_location: "",
    tourniquet_location: {
      tourniquet_location_1: "",
      tourniquet_location_2: "",
      tourniquet_location_3: "",
      tourniquet_location_4: "",
      tourniquet_location_5: "",
      tourniquet_location_6: "",
    },
    applied_time: {
      applied_time_1: "",
      applied_time_2: "",
      applied_time_3: "",
      applied_time_4: "",
      applied_time_5: "",
      applied_time_6: "",
    },
    released_time: {
      released_time_1: "",
      released_time_2: "",
      released_time_3: "",
      released_time_4: "",
      released_time_5: "",
      released_time_6: "",
    },
    other_equipment_used: "",
    other_equipment_used_other: "",
    other_equipment_used_other2: "",
    other_equipment_used_other3: "",
    other_equipment_used_other4: "",
    other_equipment_used_other5: "",
    other_equipment_used_other6: "",
    prbc_units: {
      prbc_units_1: "",
      prbc_units_2: "",
      prbc_units_3: "",
    },
    ffp_units: {
      ffp_units_1: "",
      ffp_units_2: "",
      ffp_units_3: "",
    },
    platelets_units: {
      platelets_units_1: "",
      platelets_units_2: "",
      platelets_units_3: "",
    },
    other_blood_units: {
      other_blood_units_1: "",
      other_blood_units_2: "",
      other_blood_units_3: "",
    },
    name_of_surgeon: "",
    name_of_assistant: "",
    name_of_anesthetist: "",
    name_of_assistant_anesthesia: "",
    packing_type: {
      packing_type_1: "",
      packing_type_2: "",
      packing_type_3: "",
      packing_type_4: "",
      packing_type_5: "",
      packing_type_6: "",
    },
    packing_size: {
      packing_size_1: "",
      packing_size_2: "",
      packing_size_3: "",
      packing_size_4: "",
      packing_size_5: "",
      packing_size_6: "",
    },
    packing_site: {
      packing_site_1: "",
      packing_site_2: "",
      packing_site_3: "",
      packing_site_4: "",
      packing_site_5: "",
      packing_site_6: "",
    },
    packing_output: {
      packing_output_1: "",
      packing_output_2: "",
      packing_output_3: "",
      packing_output_4: "",
      packing_output_5: "",
      packing_output_6: "",
    },
    packing_sign: "",
    packing_sign2: "",
    packing_sign3: "",
    packing_sign4: "",
    packing_sign5: "",
    packing_sign6: "",

    nurses_notes: "",
    blood_transfusion: "",
    blood_transfusion_if_yes: "",
    condition_of_patient: "",
    type_of_specimen: "",
    lab: "",
    frozen_section_time_sent: "",
    frozen_section_time_received: "",
    name_of_pathologist: "",
    condition_of_patient_text: "",
    transferred_to_recovery_icu: "",
    scrub_nurse_signature: "",
    scrub_nurse_datetime: "",
    circulating_nurse_signature: "",
    circulating_nurse_datetime: "",
    name_of_implant: "",
  });
  const selected = Object.keys(formData.pressure_protection_pad)
    .filter((test) => formData.pressure_protection_pad[test])
    .map((test) => test);
  const selectedTests = Object.keys(formData.tourniquet_location)
    .filter((test) => formData.tourniquet_location[test])
    .reduce((acc, key) => {
      acc[key] = formData.tourniquet_location[key];
      return acc;
    }, {});

  const selectedTests2 = Object.keys(formData.applied_time)
    .filter((test) => formData.applied_time[test])
    .reduce((acc, key) => {
      acc[key] = formData.applied_time[key];
      return acc;
    }, {});

  const selectedTests3 = Object.keys(formData.released_time)
    .filter((test) => formData.released_time[test])
    .reduce((acc, key) => {
      acc[key] = formData.released_time[key];
      return acc;
    }, {});

  const selectedTests4 = Object.keys(formData.other_equipment_used)
    .filter((test) => formData.other_equipment_used[test])
    .reduce((acc, key) => {
      acc[key] = formData.other_equipment_used[key];
      return acc;
    }, {});

  const selectedTests5 = Object.keys(formData.packing_type)
    .filter((test) => formData.packing_type[test])
    .reduce((acc, key) => {
      acc[key] = formData.packing_type[key];
      return acc;
    }, {});

  const selectedTests6 = Object.keys(formData.packing_size)
    .filter((test) => formData.packing_size[test])
    .reduce((acc, key) => {
      acc[key] = formData.packing_size[key];
      return acc;
    }, {});

  const selectedTests7 = Object.keys(formData.packing_site)
    .filter((test) => formData.packing_site[test])
    .reduce((acc, key) => {
      acc[key] = formData.packing_site[key];
      return acc;
    }, {});

  const selectedTests8 = Object.keys(formData.packing_output)
    .filter((test) => formData.packing_output[test])
    .reduce((acc, key) => {
      acc[key] = formData.packing_output[key];
      return acc;
    }, {});

  const selectedTests9 = Object.keys(formData.prbc_units)
    .filter((test) => formData.prbc_units[test])
    .reduce((acc, key) => {
      acc[key] = formData.prbc_units[key];
      return acc;
    }, {});

  const selectedTests10 = Object.keys(formData.ffp_units)
    .filter((test) => formData.ffp_units[test])
    .reduce((acc, key) => {
      acc[key] = formData.ffp_units[key];
      return acc;
    }, {});

  const selectedTests11 = Object.keys(formData.platelets_units)
    .filter((test) => formData.platelets_units[test])
    .reduce((acc, key) => {
      acc[key] = formData.platelets_units[key];
      return acc;
    }, {});

  const selectedTests12 = Object.keys(formData.other_blood_units)
    .filter((test) => formData.other_blood_units[test])
    .reduce((acc, key) => {
      acc[key] = formData.other_blood_units[key];
      return acc;
    }, {});

  const handlesubmit = async (event) => {
    // console.log(selectedTests)
    event.preventDefault();
    if (!validate()) return;
    console.log(formData);
    const data = {
      ...formData,
      hospital_id: 1,



      pressure_protection_pad: selected,

      tourniquet_location: selectedTests,
      applied_time: selectedTests2,
      released_time: selectedTests3,
      other_equipment_used: selectedTests4,
      packing_type: selectedTests5,
      packing_size: selectedTests6,
      packing_site: selectedTests7,
      packing_output: selectedTests8,
      prbc_units: selectedTests9,
      ffp_units: selectedTests10,
      platelets_units: selectedTests11,
      other_blood_units: selectedTests12,
      blood_transfusion: formData.blood_transfusion || "No",
    };

    console.log(data);
    try {
      if (success) {
        await axios.put(`${API_BASE_URL}/update_intra_op_record/${uhid_no}`, data,
          { withCredentials: true });
        showNotification('success', "Intra-operative Nursing Record Form updated successfully!");
      } else {
        const response = await axios.post(`${API_BASE_URL}/intra_op_record`, data,
          { withCredentials: true });
        console.log('Form Submitted: ', response.data);
        showNotification('success', 'Intra-operative Nursing Record Form submitted successfully!');
      }
      clearDraft(DRAFT_KEYS.INTRAOPERATIVE_NURSING_RECORD, uhid_no);
      navigate(`/mainPage/${formData.uhid_no}`, {
        state: { from: 'IntraOperativePhase', status: 'success', step: 2 },
      });
    } catch (error) {
      console.error('There was an error submitting the form!', error);
      showNotification('error', "Error in submitting Intra-operative Nursing Record Form!");
    }
  }

  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [currentSignatureRole, setCurrentSignatureRole] = useState("");
  const signaturePadRef = useRef(null);

  const handleSignatureOpen = (signatureKey) => {
    // Map signature key to datetime field key
    const datetimeKey =
      signatureKey === "scrub_nurse_signature"
        ? "scrub_nurse_datetime"
        : signatureKey === "circulating_nurse_signature"
          ? "circulating_nurse_datetime"
          : null;

    if (datetimeKey) {
      const now = new Date().toISOString().slice(0, 16); // e.g. "2025-06-04T13:45"
      setFormData((prev) => ({
        ...prev,
        [datetimeKey]: now,
      }));
    }

    setCurrentSignatureRole(signatureKey);
    setSignatureDialogOpen(true);
  };

  const handleSignatureClear = () => {
    signaturePadRef.current.clear();
  };
  const handleDialogClose = () => {
    setSignatureDialogOpen(false);
  };
  const handleSignatureSave = () => {
    const dataURL = signaturePadRef.current.toDataURL();
    setFormData((prevData) => ({
      ...prevData,
      [currentSignatureRole]: dataURL.split(",")[1],
    }));
    if (currentSignatureRole) {
      formData[currentSignatureRole] = dataURL.split(",")[1]; // Update the formData with the new signature
    }
    setSignatureDialogOpen(false);
  };

  const doctorGroups = {
    Cardiologists: [
      "Dr. John Smith",
      "Dr. Emily Johnson",
      "Dr. Michael Brown",
      "Dr. Sarah Davis",
      "Dr. William Wilson",
      "Dr. Linda Martinez"
    ],
    Neurologists: [
      "Dr. Robert Lee",
      "Dr. Patricia Taylor",
      "Dr. James Anderson",
      "Dr. Barbara Thomas",
      "Dr. David Jackson",
      "Dr. Susan White"
    ],
    Orthopedics: [
      "Dr. Richard Garcia",
      "Dr. Jennifer Harris",
      "Dr. Charles Clark",
      "Dr. Jessica Lewis",
      "Dr. Thomas Robinson",
      "Dr. Karen Walker"
    ],
    Dermatologists: [
      "Dr. Nancy Young",
      "Dr. Matthew Hall",
      "Dr. Donna Allen",
      "Dr. Steven King",
      "Dr. Michelle Wright",
      "Dr. George Scott"
    ],
    Gynecologists: [
      "Dr. Sandra Green",
      "Dr. Kevin Adams",
      "Dr. Laura Baker",
      "Dr. Mark Nelson",
      "Dr. Angela Carter",
      "Dr. Brian Mitchell"
    ],
    Pediatricians: [
      "Dr. Melissa Perez",
      "Dr. Eric Roberts",
      "Dr. Deborah Turner",
      "Dr. Jason Phillips",
      "Dr. Rebecca Campbell",
      "Dr. Andrew Parker"
    ],
    AnaesthesiaSpecialists: [
      "Dr. Anil Mehta",
      "Dr. Priya Iyer",
      "Dr. Rakesh Nair",
      "Dr. Neha Sharma",
      "Dr. Vivek Rao",
      "Dr. Aarti Desai"
    ]
  };
  const nurseGroups = {
    ICU: [
      "Nurse Anna Smith",
      "Nurse Brian Lee",
      "Nurse Carol White",
      "Nurse David Green",
      "Nurse Emma Black",
      "Nurse Frank Harris",
    ],
    Pediatrics: [
      "Nurse Emily Davis",
      "Nurse Frank Miller",
      "Nurse Grace Wilson",
      "Nurse Hannah Moore",
      "Nurse Ian Clark",
      "Nurse Julia Lewis",
    ],
    GeneralWard: [
      "Nurse Henry Brown",
      "Nurse Irene Clark",
      "Nurse Jack Harris",
      "Nurse Kelly Martinez",
      "Nurse Liam Thompson",
      "Nurse Mia Anderson",
    ],
    Emergency: [
      "Nurse Karen Scott",
      "Nurse Larry Adams",
      "Nurse Monica Turner",
      "Nurse Nathan Hill",
      "Nurse Olivia King",
      "Nurse Peter Wright",
    ],
    Surgery: [
      "Nurse Quinn Young",
      "Nurse Rachel Walker",
      "Nurse Samuel Hall",
      "Nurse Tina Allen",
      "Nurse Victor Baker",
      "Nurse Wendy Nelson",
    ],
    Maternity: [
      "Nurse Xavier Perez",
      "Nurse Yolanda Roberts",
      "Nurse Zoe Campbell",
      "Nurse Aaron Phillips",
      "Nurse Bethany Parker",
      "Nurse Chris Turner",
    ],
  };

  const handleChange = (event) => {
    if (!event.target) {
      console.error("Event target is undefined");
      return;
    }

    const { name, type, checked, value } = event.target;

    // Regex for allowed characters (letters, numbers, hyphen, underscore, space)
    const regex = /^[a-zA-Z0-9]+(?:[._\s-]*[a-zA-Z0-9]+)*$/;
    ;

    // Apply validation only for name fields (adjust condition as needed)
    if (name.toLowerCase().includes("name") && value && !regex.test(value)) {
      console.warn("Invalid character detected in name field. Only letters, numbers, hyphens, underscores, and spaces are allowed.");
      return;
    }

    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: type === "checkbox" ? checked : value,
        },
      }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";
    switch (name) {
      case 'diagnosis':
        if (!value) error = "Diagnosis is required";
        break;
      case 'name_of_surgery':
        if (!value) error = "Name of Surgery is required";
        break;
      case 'or_no':
        if (!value) error = "OR No is required";
        break;
      case 'monopolar_pad_location':
        if (!value) error = "Monopolar Pad Location is required";
        break;
      case 'name_of_surgeon':
        if (!value) error = "Surgeon name is required";
        break;
      case 'name_of_anesthetist':
        if (!value) error = "Anesthetist name is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const validate = () => {
    const tempErrors = {};
    if (!formData.diagnosis) tempErrors.diagnosis = "Diagnosis is required";
    if (!formData.name_of_surgery) tempErrors.name_of_surgery = "Name of Surgery is required";
    if (!formData.or_no) tempErrors.or_no = "OR No is required";
    if (!formData.monopolar_pad_location) tempErrors.monopolar_pad_location = "Monopolar Pad Location is required";
    if (!formData.name_of_surgeon) tempErrors.name_of_surgeon = "Surgeon name is required";
    if (!formData.name_of_anesthetist) tempErrors.name_of_anesthetist = "Anesthetist name is required";

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstErrorField = Object.keys(tempErrors)[0];
      const errorElement = document.querySelector(`[name="${firstErrorField}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorElement.focus();
      }
      showNotification('error', "Please fill in all required fields.");
    }

    return Object.keys(tempErrors).length === 0;
  };


  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [ipRes] = await Promise.all([

          axios.get(`${API_BASE_URL}/intra_op_next_ip`)
        ]);
        setFormData(prev => ({
          ...prev,

          ip_no: ipRes.data.next_ip_no
        }));
      } catch (error) {
        console.error('Failed to fetch initial data:', error);
      }
    };

    fetchInitialData();
  }, []);
  const fetchPatientData = async (uhidNo) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/get_patient_intra_op_api/${uhidNo}`);
      setPatient(response.data);
      console.log(response.data);
      setFormData(prev => ({
        ...prev,

        name: response.data.name,
        age: response.data.age,
        sex: response.data.sex
      }));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      setError('Failed to fetch patient data. Please try again.');
      setLoading(false);
    }
  };
  useEffect(() => {
    // Fetch data when component mounts or uhid_no changes
    axios.get(`${API_BASE_URL}/get_intra_op_record/${uhid_no}`)
      .then((response) => {
        const data = response.data;
        console.log(data)
        // List of fields that are stored as JSON strings in backend — parse them
        const jsonFields = [
          'applied_time',
          'released_time',
          'tourniquet_location',
          'other_equipment_used',
          'prbc_units',
          'ffp_units',
          'platelets_units',
          'other_blood_units',
          'packing_type',
          'packing_size',
          'packing_site',
          'packing_output',
        ];

        jsonFields.forEach((key) => {
          if (typeof data[key] === 'string' && data[key] !== "") {
            try {
              data[key] = JSON.parse(data[key]);
            } catch (error) {
              console.warn(`Could not parse ${key}:`, error);
            }
          }
        });

        // Convert pressure_protection_pad from JSON string array to boolean object form
        if (typeof data.pressure_protection_pad === 'string' && data.pressure_protection_pad !== "") {
          try {
            const selectedPads = JSON.parse(data.pressure_protection_pad);
            data.pressure_protection_pad = Object.keys(formData.pressure_protection_pad).reduce((acc, pad) => {
              acc[pad] = selectedPads.includes(pad);
              return acc;
            }, {});
          } catch (error) {
            console.warn('Could not parse pressure_protection_pad:', error);
          }
        }

        // Helper function: Remove seconds from time string, e.g. "14:30:00" → "14:30"
        const stripSeconds = (time) => {
          if (!time) return "";
          const parts = time.split(":");
          return parts.length >= 2 ? `${parts[0].padStart(2, "0")}:${parts[1]}` : time;
        };


        // Format nurse signature datetime fields to fit input type="datetime-local"
        const dateTimeFields = ["circulating_nurse_datetime", "scrub_nurse_datetime"];
        const formattedDateTimes = {};
        dateTimeFields.forEach(field => {
          if (data[field]) {
            formattedDateTimes[field] = new Date(data[field]).toISOString().slice(0, 16);
          }
        });

        // Set the form data state with all parsed and formatted fields
        setFormData(prev => ({
          ...prev,
          ...data,
          wheel_in_time: stripSeconds(data.wheel_in_time),
          wheel_out_time: stripSeconds(data.wheel_out_time),
          anesthesia_start_time: stripSeconds(data.anesthesia_start_time),
          anesthesia_end_time: stripSeconds(data.anesthesia_end_time),
          incision_time: stripSeconds(data.incision_time),
          closure_time: stripSeconds(data.closure_time),
          mode_of_transfer_to_ot: data.mode_of_transfer_to_ot || "",
          anesthesia_type: data.anesthesia_type || "",
          frozen_section_time_sent: stripSeconds(data.frozen_section_time_sent),
          frozen_section_time_received: stripSeconds(data.frozen_section_time_received),
          tourniquet_location: {
            tourniquet_location_1: data.tourniquet_location.tourniquet_location_1 || "",
            tourniquet_location_2: data.tourniquet_location.tourniquet_location_2 || "",
            tourniquet_location_3: data.tourniquet_location.tourniquet_location_3 || "",
            tourniquet_location_4: data.tourniquet_location.tourniquet_location_4 || "",
            tourniquet_location_5: data.tourniquet_location.tourniquet_location_5 || "",
            tourniquet_location_6: data.tourniquet_location.tourniquet_location_6 || "",
          },
          applied_time: {
            applied_time_1: data.applied_time.applied_time_1 || "",
            applied_time_2: data.applied_time.applied_time_2 || "",
            applied_time_3: data.applied_time.applied_time_3 || "",
            applied_time_4: data.applied_time.applied_time_4 || "",
            applied_time_5: data.applied_time.applied_time_5 || "",
            applied_time_6: data.applied_time.applied_time_6 || "",
          },
          released_time: {
            released_time_1: data.released_time.released_time_1 || "",
            released_time_2: data.released_time.released_time_2 || "",
            released_time_3: data.released_time.released_time_3 || "",
            released_time_4: data.released_time.released_time_4 || "",
            released_time_5: data.released_time.released_time_5 || "",
            released_time_6: data.released_time.released_time_6 || "",
          },
          other_equipment_used: data.other_equipment_used || "",
          other_equipment_used_other: data.other_equipment_used_other || "",
          other_equipment_used_other2: data.other_equipment_used_other2 || "",
          other_equipment_used_other3: data.other_equipment_used_other3 || "",
          other_equipment_used_other4: data.other_equipment_used_other4 || "",
          other_equipment_used_other5: data.other_equipment_used_other5 || "",
          other_equipment_used_other6: data.other_equipment_used_other6 || "",
          prbc_units: {
            prbc_units_1: data.prbc_units.prbc_units_1 || "",
            prbc_units_2: data.prbc_units.prbc_units_2 || "",
            prbc_units_3: data.prbc_units.prbc_units_3 || "",
          },
          ffp_units: {
            ffp_units_1: data.ffp_units.ffp_units_1 || "",
            ffp_units_2: data.ffp_units.ffp_units_2 || "",
            ffp_units_3: data.ffp_units.ffp_units_3 || "",
          },
          platelets_units: {
            platelets_units_1: data.platelets_units.platelets_units_1 || "",
            platelets_units_2: data.platelets_units.platelets_units_2 || "",
            platelets_units_3: data.platelets_units.platelets_units_3 || "",
          },
          other_blood_units: {
            other_blood_units_1: data.other_blood_units.other_blood_units_1 || "",
            other_blood_units_2: data.other_blood_units.other_blood_units_2 || "",
            other_blood_units_3: data.other_blood_units.other_blood_units_3 || "",
          },
          name_of_surgeon: data.name_of_surgeon || "",
          name_of_assistant: data.name_of_assistant || "",
          name_of_anesthetist: data.name_of_anesthetist || "",
          name_of_assistant_anesthesia: data.name_of_assistant_anesthesia || "",
          packing_type: {
            packing_type_1: data.packing_type.packing_type_1 || "",
            packing_type_2: data.packing_type.packing_type_2 || "",
            packing_type_3: data.packing_type.packing_type_3 || "",
            packing_type_4: data.packing_type.packing_type_4 || "",
            packing_type_5: data.packing_type.packing_type_5 || "",
            packing_type_6: data.packing_type.packing_type_6 || "",
          },
          packing_size: {
            packing_size_1: data.packing_size.packing_size_1 || "",
            packing_size_2: data.packing_size.packing_size_2 || "",
            packing_size_3: data.packing_size.packing_size_3 || "",
            packing_size_4: data.packing_size.packing_size_4 || "",
            packing_size_5: data.packing_size.packing_size_5 || "",
            packing_size_6: data.packing_size.packing_size_6 || "",
          },
          packing_site: {
            packing_site_1: data.packing_site.packing_site_1 || "",
            packing_site_2: data.packing_site.packing_site_2 || "",
            packing_site_3: data.packing_site.packing_site_3 || "",
            packing_site_4: data.packing_site.packing_site_4 || "",
            packing_site_5: data.packing_site.packing_site_5 || "",
            packing_site_6: data.packing_site.packing_site_6 || "",
          },
          packing_output: {
            packing_output_1: data.packing_output.packing_output_1 || "",
            packing_output_2: data.packing_output.packing_output_2 || "",
            packing_output_3: data.packing_output.packing_output_3 || "",
            packing_output_4: data.packing_output.packing_output_4 || "",
            packing_output_5: data.packing_output.packing_output_5 || "",
            packing_output_6: data.packing_output.packing_output_6 || "",
          },
          packing_sign: data.packing_sign || "",
          packing_sign2: data.packing_sign2 || "",
          packing_sign3: data.packing_sign3 || "",
          packing_sign4: data.packing_sign4 || "",
          packing_sign5: data.packing_sign5 || "",
          packing_sign6: data.packing_sign6 || "",

          position: data.position || "",
          ...formattedDateTimes,
        }));

        setSuccess("success");
      })
      .catch((error) => {
        console.error("Error loading intra-op record:", error);
      });
    fetchPatientData(uhid_no); // Fetch patient data when uhid_no changes
  }, [uhid_no]);

  const medicalConditions = [
    'Asthma',
    'Diabetes',
    'Hypertension',
    'Hyperthyroidism',
    'Hypothyroidism',
    'Anemia',
    'Chronic Fatigue Syndrome',
    'Obesity',
    'Cancer',
    'Stroke',
    'Epilepsy',
    'Multiple Sclerosis',
    'Parkinson’s Disease',
    'Osteoarthritis',
    'Rheumatoid Arthritis',
    'Gout',
    'Psoriasis',
    'Irritable Bowel Syndrome (IBS)',
    'Celiac Disease',
    'Lactose Intolerance',
    'Gastroesophageal Reflux Disease (GERD)',
    'Peptic Ulcer Disease',
    'Chronic Kidney Disease',
    'Liver Cirrhosis',
    'Hepatitis B',
    'Hepatitis C',
    'Tuberculosis',
    'HIV/AIDS',
    'Chronic Obstructive Pulmonary Disease (COPD)',
    'Sleep Apnea',
    'Insomnia',
    'Anxiety Disorder',
    'Depression',
    'Bipolar Disorder',
    'Schizophrenia',
    'Attention Deficit Hyperactivity Disorder (ADHD)',
    'Autism Spectrum Disorder',
    'Post-Traumatic Stress Disorder (PTSD)',
    'Obsessive-Compulsive Disorder (OCD)',
  ];

  const surgeryOptions = [
    'Appendectomy',
    'Cholecystectomy',
    'Coronary Artery Bypass Grafting (CABG)',
    'Hysterectomy',
    'Mastectomy',
    'Prostatectomy',
    'Tonsillectomy',
    'Laparotomy',
    'Laparoscopy',
    'Cataract Surgery',
    'Spinal Fusion',
    'Hip Replacement',
    'Knee Replacement',
    'Cesarean Section (C-Section)',
    'Gallbladder Removal',
    'Hernia Repair',
    'Aortic Aneurysm Repair',
    'Kidney Transplant',
    'Liver Transplant',
    'Heart Valve Replacement',
    'Appendix Removal',
    'Thyroidectomy',
    'Lung Resection',
    'Pancreatectomy',
    'Colostomy',
    'Gastrectomy',
    'Nephrectomy',
    'Splenectomy',
    'Adrenalectomy',
    'Cholecystostomy',
    'Cystectomy',
    'Mastectomy',
    'Oophorectomy',
    'Orchiectomy',
    'Parotidectomy',
    'Pneumonectomy',
    'Prostatectomy',
    'Salpingectomy',
    'Thyroidectomy',
    'Tonsillectomy and Adenoidectomy',
    'Vasectomy',
    'Whipple Procedure',
  ];

  const Locations = [
    'Right Upper Arm',
    'Left Upper Arm',
    'Right Lower Leg',
    'Left Lower Leg',
    'Right Thigh',
    'Left Thigh',
    'Right Flank',
    'Left Flank',
    'Right Abdomen',
    'Left Abdomen',
    'Right Chest',
    'Left Chest',
  ];
  const orNumbers = [
    'OR12345',
    'OR12346',
    'OR12347',
    'OR12348',
    'OR12349',
    'OR12350',
    // Add more OR numbers as needed
  ];


  const equipmentOptions = [
    'Head Rest',
    'Sand Bag',
    'Pillow',
    'Axillary Roll',
    'Shoulder Roll',
    'Eye Protection',
    'Chest Roll',
    'Sling',
    'Boot',
    'Stirrups',
    'Leg Holder',
    'L Arm Padded, Tucked & Secured',
    'R Arm Padded, Tucked & Secured',
  ];
  const packingTypes = [
    { label: 'Gauze' },
    { label: 'Hydrocolloid' },
    { label: 'Foam' },
    { label: 'Alginate' },
    { label: 'Silver-impregnated' },
  ];
  const sizeOptions = [
    { label: 'Small' },
    { label: 'Medium' },
    { label: 'Large' },
    { label: 'Extra Large' },
  ];
  const outputOptions = [
    { label: 'Minimal' },
    { label: 'Moderate' },
    { label: 'Heavy' },
  ];
  const siteOptions = [
    { label: 'Wound 1' },
    { label: 'Wound 2' },
    { label: 'Wound 3' },
    { label: 'Wound 4' },
  ];
  const [dataLoaded, setDataLoaded] = useState(false);

  // Load draft data on component mount
  useEffect(() => {
    const draftData = loadDraft(DRAFT_KEYS.INTRAOPERATIVE_NURSING_RECORD, uhid_no);
    if (draftData) {
      setFormData(prev => ({ ...prev, ...draftData.formData }));
    }
    setDataLoaded(true);
  }, [uhid_no]);

  // Auto-save draft functionality
  useEffect(() => {
    if (!dataLoaded) return; // Don't auto-save until initial data is loaded

    const timeoutId = setTimeout(() => {
      if (hasFormData()) {
        saveDraft(DRAFT_KEYS.INTRAOPERATIVE_NURSING_RECORD, uhid_no, formData);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [formData, dataLoaded, uhid_no]);

  // Check if form has any data
  const hasFormData = () => {
    return Object.values(formData).some(value => {
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(subValue =>
          typeof subValue === 'string' ? subValue.trim() !== '' : subValue
        );
      }
      return value === true;
    });
  };

  // Home button handler
  const handleHomeNavigation = () => {
    if (hasFormData()) {
      // Store form status for home page to show "Continue" button
      sessionStorage.setItem(`formStatus_intra_opertive_${uhid_no}`, JSON.stringify({
        formName: 'INTRA OPERATIVE NURSING RECORD',
        uhid_no: uhid_no,
        status: 'incomplete',
        lastSaved: new Date().toISOString(),
        continueUrl: `/intraOperativeNursingRecord/${uhid_no}`
      }));
    }
    navigate('/home');
  };
  const handleBack = () => {
    navigate(`/mainPage/${formData.uhid_no}`, {
      state: { from: 'IntraOperativePhase', status: 'success', step: 2 },
    });// Navigate to the previous page
  };
  const hospitalTeams = [
    "Hospital A",
    "Hospital B",
    "Hospital C",
    "Team X",
    "Team Y",
    "Team Z",

  ];


  const bloodUnitTypes = [
    "PRBC - O Negative",
    "PRBC - A Positive",
    "FFP - Group AB",
    "Platelets - Apheresis",
    "Cryoprecipitate",
    "Whole Blood",
    "Washed Red Cells",
    "Irradiated Blood",
    // etc.
  ];
  const patientConditionSuggestions = [
    "Stable – transferred to recovery room",
    "Stable with close monitoring",
    "Critical – shifted to ICU",
    "Unstable – resuscitation ongoing",
    "Hemodynamically stable",
    "Requires ventilator support",
    "Post-operative bleeding observed",
    "Condition deteriorating – critical care initiated",
    "Stable but drowsy – under observation",
    "Critical – under inotropic support",
  ];
  const specimenTypes = [
    "Tissue biopsy",
    "Blood sample",
    "Urine sample",
    "Sputum",
    "Bone marrow",
    "CSF (Cerebrospinal Fluid)",
    "Pleural fluid",
    "Ascitic fluid",
    "Wound swab",
    "Pus",
    "Surgical specimen",
    "Tumor mass",
    "Lymph node",
    "Synovial fluid",
  ];
  const transferDestinations = [
    "Recovery Room",
    "Surgical ICU (SICU)",
    "Medical ICU (MICU)",
    "Pediatric ICU (PICU)",
    "Neonatal ICU (NICU)",
    "High Dependency Unit (HDU)",
    "Post-Anesthesia Care Unit (PACU)",
    "General Ward",
    "Transferred to Home",
    "Not Applicable",
  ];
  const implantNameSuggestions = [
    "Hip prosthesis",
    "Knee implant",
    "Dental implant",
    "Pacemaker",
    "Cochlear implant",
    "Spinal fusion device",
    "Intraocular lens",
    "Breast implant",
    "Cardiac stent",
    "Vascular graft",
  ];

  const transfusionReasons = [
    "Severe anemia",
    "Post-surgical blood loss",
    "Hemorrhage",
    "Low hemoglobin",
    "Cancer treatment",
    "Bleeding disorder",
    "Platelet transfusion need",
    "Massive trauma",
    "Chronic kidney disease",
    "ICU requirement",
  ];

  const combinedSuggestions = [...bloodUnitTypes];

  const goToVideoRecorder = (formName, uhid_no) => {
    navigate(`/video?form=${encodeURIComponent(formName)}&uhid_no=${encodeURIComponent(uhid_no)}`);
  };
  const [submitStatus, setSubmitStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const handleShareClick = async () => {
    try {
      // Call API to generate a share token for the given UHID
      const res = await axios.post(`${API_BASE_URL}/generate_for_intra_op_share_token/${uhid_no}`);

      const token = res.data.token;
      const link = `${API_BASE_URL}/intraOperativeNursingRecord/${uhid_no}?token=${token}`;
      const message = `Dear Doctor,\n\nPlease fill the post-operative analgesia chart:\n\n${link}`;

      // Copy the shareable link to clipboard
      await navigator.clipboard.writeText(link);

      // Show success notification to user
      setSubmitStatus({
        open: true,
        message: "Secure link copied to clipboard!",
        severity: "info",
      });

      // Open WhatsApp chat with pre-filled message (replace phone number if needed)
      const phoneNumber = '+916379605575'; // no spaces or special chars for wa.me
      window.open(`http://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } catch (error) {
      console.error("Error generating share token:", error);

      // Show error notification to user
      setSubmitStatus({
        open: true,
        message: "Failed to generate shareable link",
        severity: "error",
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Paper elevation={3} sx={{ padding: 3 }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
            {/* Heading with Icon */}
            <Typography
              variant="h4"
              sx={{
                color: '#008080',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 600,
                letterSpacing: 0.5,
              }}
            >

              INTRA OPERATIVE NURSING RECORD
            </Typography>

            {/* Right-aligned Logo and Text */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="Logo" className="w-8 h-8" />
              <Typography
                variant="h6"
                sx={{
                  color: '#008080',
                  marginLeft: 1,
                  fontWeight: 500,
                  letterSpacing: 0.3,
                }}
              >
                OTMS
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            {/* Left-aligned Back Button */}
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ marginLeft: 2 }}
            >
              Back
            </Button>

            {/* Right-aligned Buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                onClick={handleHomeNavigation}
                sx={{ marginRight: 1 }}
              >
                Home
              </Button>
              <Button
                variant="contained"
                onClick={() => goToVideoRecorder("INTRA OPERATIVE NURSING RECORD", uhid_no)}
                sx={{ marginRight: 1 }}
              >
                Add Iterative Video
              </Button>
              <IconButton color="primary" aria-label="share" onClick={handleShareClick}>
                <ShareIcon />
              </IconButton>
            </Box>
          </Box>




          <Divider sx={{ my: 2 }} />
          {/* Diagnosis & Surgery Details */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="IP NO"
                fullWidth
                name="ip_no"
                type="number"
                InputProps={{ readOnly: true, }}
                value={formData.ip_no}
                onChange={handleChange}

              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="UHID NO"
                fullWidth
                name="uhid_no"
                value={formData.uhid_no}
                onChange={handleChange}
                InputProps={{ readOnly: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                freeSolo
                options={medicalConditions} // Replace with your list of medical conditions
                value={formData.diagnosis}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    diagnosis: newValue,
                  }));
                  if (errors.diagnosis) {
                    setErrors((prev) => ({ ...prev, diagnosis: "" }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Diagnosis"
                    fullWidth
                    name="diagnosis"
                    required
                    error={!!errors.diagnosis}
                    helperText={errors.diagnosis}
                    onBlur={handleBlur}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                freeSolo
                options={surgeryOptions}
                value={formData.name_of_surgery}

                onChange={(_, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    name_of_surgery: newValue,
                  }));
                  if (errors.name_of_surgery) {
                    setErrors((prev) => ({ ...prev, name_of_surgery: "" }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Name of Surgery"
                    fullWidth
                    name="name_of_surgery"
                    required
                    error={!!errors.name_of_surgery}
                    helperText={errors.name_of_surgery}
                    onBlur={handleBlur}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                freeSolo
                options={orNumbers}
                value={formData.or_no}
                onChange={(_, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    or_no: newValue,
                  }));
                  if (errors.or_no) {
                    setErrors((prev) => ({ ...prev, or_no: "" }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="OR No"
                    fullWidth
                    name="or_no"
                    required
                    error={!!errors.or_no}
                    helperText={errors.or_no}
                    onBlur={handleBlur}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Wheel In Time"
                type="time"
                fullWidth
                InputLabelProps={{ shrink: true }}
                name="wheel_in_time"
                value={formData.wheel_in_time}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Wheel Out Time"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                name="wheel_out_time"
                value={formData.wheel_out_time}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Anesthesia Start Time"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                name="anesthesia_start_time"
                value={formData.anesthesia_start_time}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Anesthesia End Time"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                name="anesthesia_end_time"
                value={formData.anesthesia_end_time}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Incision Time"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                name="incision_time"
                value={formData.incision_time}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Closure Time"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                name="closure_time"
                value={formData.closure_time}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          {/* Transfer to OT */}
          <Typography variant="h6" gutterBottom mt={2}>
            Mode of Transfer to OT
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup row name="mode_of_transfer_to_ot" onChange={handleChange} value={formData.mode_of_transfer_to_ot}>
              <FormControlLabel value="Bed" control={<Radio />} label="Bed" />
              <FormControlLabel value="Stretcher" control={<Radio />} label="Stretcher" />
              <FormControlLabel value="Wheelchair" control={<Radio />} label="Wheel Chair" />
            </RadioGroup>
          </FormControl>
          <Divider sx={{ my: 2 }} />
          {/* Anesthesia Type */}
          <Typography variant="h6" gutterBottom>
            Anesthesia Type
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup row name="anesthesia_type" onChange={handleChange} value={formData.anesthesia_type}>
              {["Epidural", "Spinal", "Local", "Regional", "GA"].map((type) => (
                <FormControlLabel key={type} value={type} control={<Radio />} label={type} />
              ))}
            </RadioGroup>
          </FormControl>
          <Divider sx={{ my: 2 }} />
          {/* Position */}
          <Typography variant="h6" gutterBottom>
            Position
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup row name="position" onChange={handleChange} value={formData.position}>
              {["Supine", "Prone", "Lithotomy", "Right Lateral", "Left Lateral", "Other"].map((pos) => (
                <FormControlLabel key={pos} value={pos} control={<Radio />} label={pos} />
              ))}
            </RadioGroup>
          </FormControl>
          <Divider sx={{ my: 2 }} />
          {/* Pressure Protection Pads */}
          <Typography variant="h6" gutterBottom>
            Pressure Protection Pads
          </Typography>
          <Grid container>
            {Object.keys(formData.pressure_protection_pad).map((test) => (
              <Grid item xs={6} sm={4} key={test}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.pressure_protection_pad[test]}
                      onChange={handleChange}
                      name={`pressure_protection_pad.${test}`}
                    />
                  }
                  label={test.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
                />
              </Grid>
            ))}
          </Grid>
          <h5>Other</h5>
          <TextField
            fullWidth
            name="pressure_protection_pad_other"
            label="Other"
            variant="outlined"
            margin="normal"
            value={formData.pressure_protection_pad_other}
            onChange={handleChange}
          />
          <Divider sx={{ my: 2 }} />

          <TextField
            select
            label="Skin Preparation"
            placeholder="Chlorhexidine, Povidone iodine, etc."
            fullWidth
            margin="normal"
            name="skin_preparation"
            value={formData.skin_preparation}
            onChange={handleChange}
          >
            <MenuItem value="Chlorhexidine">Chlorhexidine</MenuItem>
            <MenuItem value="Povidone iodine">Povidone iodine</MenuItem>
            <MenuItem value="lodophor scrub">lodophor scrub</MenuItem>
            <MenuItem value="Alcohol prep">Alcohol prep</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
          {formData.skin_preparation === "Other" && (
            <TextField
              fullWidth
              label="Other skin preparation"
              name="skin_preparation_other"
              value={formData.skin_preparation_other}
              variant="outlined"
              onChange={handleChange}
            />
          )}
          <Divider sx={{ my: 2 }} />

          {/* Electro cautery & Tourniquet */}
          <Typography variant="h6" gutterBottom mt={2}>
            Electrocautery: Monopolar Pad Location
          </Typography>
          <Autocomplete
            freeSolo
            options={Locations}
            value={formData.monopolar_pad_location}

            onChange={(_, newValue) => {
              setFormData((prev) => ({
                ...prev,
                monopolar_pad_location: newValue,
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Monopolar Pad Location"
                fullWidth
                name="monopolar_pad_location"
                required
                error={!!errors.monopolar_pad_location}
                helperText={errors.monopolar_pad_location}
                onBlur={handleBlur}
              />
            )}
          />
          <br />
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Tourniquet: Location</TableCell>
                  <TableCell>Applied Time</TableCell>
                  <TableCell>Released Time</TableCell>
                  <TableCell>Other Equipment used</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formData.tourniquet_location &&
                  Object.keys(formData.tourniquet_location).map((locationKey, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <TextField
                          name={`tourniquet_location.${locationKey}`}
                          value={formData.tourniquet_location[locationKey]}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="time"
                          name={`applied_time.applied_time_${index + 1}`}
                          value={formData.applied_time[`applied_time_${index + 1}`]}
                          onChange={handleChange}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="time"
                          name={`released_time.released_time_${index + 1}`}
                          value={formData.released_time[`released_time_${index + 1}`]}
                          onChange={handleChange}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name={`other_equipment_used.equipment_${index + 1}`}
                          value={formData.other_equipment_used[`equipment_${index + 1}`]}
                          onChange={handleChange}
                          fullWidth
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Divider sx={{ my: 2 }} />
          <Grid container spacing={2}>
            {/* Surgeon & Assistant Details */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.name_of_surgeon}>
                <InputLabel id="surgeon-label">Name of Surgeon</InputLabel>
                <Select
                  labelId="surgeon-label"
                  id="surgeon-select"
                  value={formData.name_of_surgeon}
                  label="Name of Surgeon"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="name_of_surgeon"
                  required
                >
                  <MenuItem value="Dr. Sarah Johnson">Dr. Sarah Johnson</MenuItem>
                  <MenuItem value="Dr. Michael Chen">Dr. Michael Chen</MenuItem>
                  <MenuItem value="Dr. Emily Rodriguez">Dr. Emily Rodriguez</MenuItem>
                  <MenuItem value="Dr. David Kim">Dr. David Kim</MenuItem>
                  <MenuItem value="Dr. Lisa Thompson">Dr. Lisa Thompson</MenuItem>
                  <MenuItem value="Dr. James Wilson">Dr. James Wilson</MenuItem>
                  <MenuItem value="Dr. Maria Garcia">Dr. Maria Garcia</MenuItem>
                  <MenuItem value="Dr. Robert Anderson">Dr. Robert Anderson</MenuItem>
                </Select>
                {errors.name_of_surgeon && <FormHelperText>{errors.name_of_surgeon}</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="assistant-label">Name of Assistant</InputLabel>
                <Select
                  labelId="assistant-label"
                  id="assistant-select"
                  value={formData.name_of_assistant}
                  label="Name of Assistant"
                  onChange={handleChange}
                  name="name_of_assistant"
                >
                  <MenuItem value="Nurse Jennifer Smith">Nurse Jennifer Smith</MenuItem>
                  <MenuItem value="Nurse Carlos Martinez">Nurse Carlos Martinez</MenuItem>
                  <MenuItem value="Nurse Amanda Brown">Nurse Amanda Brown</MenuItem>
                  <MenuItem value="Nurse Kevin Lee">Nurse Kevin Lee</MenuItem>
                  <MenuItem value="Surgical Tech - Mark Davis">Surgical Tech - Mark Davis</MenuItem>
                  <MenuItem value="Surgical Tech - Rachel White">Surgical Tech - Rachel White</MenuItem>
                  <MenuItem value="Anesthesia Assistant - Tom Jackson">Anesthesia Assistant - Tom Jackson</MenuItem>
                  <MenuItem value="Surgical Assistant - Diana Moore">Surgical Assistant - Diana Moore</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            {/* Anesthetist & Assistant Details */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.name_of_anesthetist}>
                <InputLabel id="anesthetist-label">Name of Anesthetist</InputLabel>
                <Select
                  labelId="anesthetist-label"
                  id="anesthetist-select"
                  value={formData.name_of_anesthetist}
                  label="Name of Anesthetist"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="name_of_anesthetist"
                  required
                >
                  <MenuItem value="Dr. Patricia Williams">Dr. Patricia Williams</MenuItem>
                  <MenuItem value="Dr. Ahmed Hassan">Dr. Ahmed Hassan</MenuItem>
                  <MenuItem value="Dr. Jennifer Lee">Dr. Jennifer Lee</MenuItem>
                  <MenuItem value="Dr. Christopher Brown">Dr. Christopher Brown</MenuItem>
                  <MenuItem value="Dr. Priya Sharma">Dr. Priya Sharma</MenuItem>
                  <MenuItem value="Dr. Alexander Moore">Dr. Alexander Moore</MenuItem>
                  <MenuItem value="Dr. Sofia Gonzalez">Dr. Sofia Gonzalez</MenuItem>
                  <MenuItem value="Dr. Benjamin Clark">Dr. Benjamin Clark</MenuItem>
                </Select>
                {errors.name_of_anesthetist && <FormHelperText>{errors.name_of_anesthetist}</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="assistant-anesthesia-label">Name of Assistant Anesthesia</InputLabel>
                <Select
                  labelId="assistant-anesthesia-label"
                  id="assistant-anesthesia-select"
                  value={formData.name_of_assistant_anesthesia}
                  label="Name of Assistant Anesthesia"
                  onChange={handleChange}
                  name="name_of_assistant_anesthesia"
                >
                  <MenuItem value="CRNA - Michelle Taylor">CRNA - Michelle Taylor</MenuItem>
                  <MenuItem value="CRNA - Daniel Rodriguez">CRNA - Daniel Rodriguez</MenuItem>
                  <MenuItem value="CRNA - Lisa Chang">CRNA - Lisa Chang</MenuItem>
                  <MenuItem value="Anesthesia Tech - Kevin Murphy">Anesthesia Tech - Kevin Murphy</MenuItem>
                  <MenuItem value="Anesthesia Tech - Sarah Johnson">Anesthesia Tech - Sarah Johnson</MenuItem>
                  <MenuItem value="Anesthesia Assistant - Ryan Davis">Anesthesia Assistant - Ryan Davis</MenuItem>
                  <MenuItem value="Anesthesia Assistant - Maria Lopez">Anesthesia Assistant - Maria Lopez</MenuItem>
                  <MenuItem value="Perfusionist - Thomas Anderson">Perfusionist - Thomas Anderson</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Typography variant="h6" gutterBottom mt={2}>
            Packing / Drains / Catheters / Irrigation Fluids
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Type</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Site</TableCell>
                  <TableCell>Output</TableCell>
                  <TableCell>Sign</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(formData.packing_type).map((key, index) => {
                  const signatureKeys = [
                    "packing_sign",
                    "packing_sign2",
                    "packing_sign3",
                    "packing_sign4",
                    "packing_sign5",
                    "packing_sign6"
                  ];
                  const signatureKey = signatureKeys[index];
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Autocomplete
                          freeSolo
                          options={packingTypes.map((option) => option.label)}
                          value={formData.packing_type[key] || ''}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `packing_type.${key}`,
                                value: newValue || '',
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `packing_type.${key}`,
                                value: newInputValue,
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Type"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <Autocomplete
                          freeSolo
                          options={sizeOptions.map((option) => option.label)}
                          value={formData.packing_size[`packing_size_${index + 1}`] || ''}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `packing_size.packing_size_${index + 1}`,
                                value: newValue || '',
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `packing_size.packing_size_${index + 1}`,
                                value: newInputValue,
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Size"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <Autocomplete
                          freeSolo
                          options={siteOptions.map((option) => option.label)}
                          value={formData.packing_site[`packing_site_${index + 1}`] || ''}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `packing_site.packing_site_${index + 1}`,
                                value: newValue || '',
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `packing_site.packing_site_${index + 1}`,
                                value: newInputValue,
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Site"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <Autocomplete
                          freeSolo
                          options={outputOptions.map((option) => option.label)}
                          value={formData.packing_output[`packing_output_${index + 1}`] || ''}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `packing_output.packing_output_${index + 1}`,
                                value: newValue || '',
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `packing_output.packing_output_${index + 1}`,
                                value: newInputValue,
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Output"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <Button
                          variant="outlined"
                          color="primary"
                          sx={{ marginTop: 2 }}
                          onClick={() => handleSignatureOpen(signatureKey)}
                        >
                          Sign Here
                        </Button>
                        {formData[signatureKey] && (
                          <img
                            src={`data:image/png;base64,${formData[signatureKey]}`}
                            alt="Signature"
                            style={{
                              marginTop: 10,
                              border: "1px solid black",
                              width: "100%",
                              height: "150px",
                            }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
            <DialogTitle>Provide Your Signature</DialogTitle>
            <DialogContent>
              <SignatureCanvas
                ref={signaturePadRef}
                canvasProps={{ width: 400, height: 200, className: "sigCanvas" }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSignatureClear} color="secondary">
                Clear
              </Button>
              <Button onClick={handleSignatureSave} color="primary">
                Done
              </Button>
            </DialogActions>
          </Dialog>
          <TextField
            label="Nurses Notes"
            multiline
            rows={4}
            fullWidth
            margin="normal"
            name="nurses_notes"
            value={formData.nurses_notes}
            onChange={handleChange}
          />
          <Typography variant="h6" gutterBottom mt={2}>
            UNIT
          </Typography>
          <TableContainer component={Paper}>
            <Table>

              <TableBody>
                {["prbc_units", "ffp_units", "platelets_units", "other_blood_units"].map((type) => (
                  <TableRow key={type}>
                    <TableCell>{type.replace(/_/g, " ").toUpperCase()}</TableCell>
                    {Object.keys(formData[type]).map((unit) => (
                      <TableCell key={unit}>
                        <Autocomplete
                          freeSolo
                          options={combinedSuggestions}
                          value={formData[type][unit]}
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: `${type}.${unit}`,
                                value: newValue || "",
                              },
                            });
                          }}
                          onInputChange={(event, newInputValue) => {
                            handleChange({
                              target: {
                                name: `${type}.${unit}`,
                                value: newInputValue,
                              },
                            });
                          }}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />

                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>

            </Table>
          </TableContainer>
          {/* Blood Transfusion */}
          <Typography variant="h6" gutterBottom>
            Blood Transfusion
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup row name="blood_transfusion" value={formData.blood_transfusion} onChange={handleChange}>
              <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="No" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
          {formData.blood_transfusion === "Yes" && (
            <Autocomplete
              freeSolo
              options={transfusionReasons}
              value={formData.blood_transfusion_if_yes}
              onChange={(event, newValue) => {
                handleChange({
                  target: {
                    name: "blood_transfusion_if_yes",
                    value: newValue || "",
                  },
                });
              }}
              onInputChange={(event, newInputValue) => {
                handleChange({
                  target: {
                    name: "blood_transfusion_if_yes",
                    value: newInputValue,
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  type="text"
                  label="If Yes"
                  fullWidth
                  multiline
                  rows={3}
                />
              )}
            />

          )}
          <br />
          <TextField
            select
            label="Condition of patient at end of surgery: "
            placeholder="Stable / Critical"
            fullWidth
            margin="normal"
            name="condition_of_patient"
            value={formData.condition_of_patient}
            onChange={handleChange}
          >
            <MenuItem value="Stable">Stable</MenuItem>
            <MenuItem value="Critical">Critical</MenuItem>
          </TextField>

          <Autocomplete
            freeSolo
            options={patientConditionSuggestions}
            value={formData.condition_of_patient_text}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "condition_of_patient_text",
                  value: newValue || "",
                },
              });
            }}
            onInputChange={(event, newInputValue) => {
              handleChange({
                target: {
                  name: "condition_of_patient_text",
                  value: newInputValue,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                type="text"
                name="condition_of_patient_text"
                label="Condition of patient at end of surgery: Stable / Critical"
                fullWidth
                multiline
                rows={3}
              />
            )}
          />


          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" gutterBottom>
            Type of Specimen
          </Typography>
          <Autocomplete
            freeSolo
            options={specimenTypes}
            value={formData.type_of_specimen}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "type_of_specimen",
                  value: newValue || "",
                },
              });
            }}
            onInputChange={(event, newInputValue) => {
              handleChange({
                target: {
                  name: "type_of_specimen",
                  value: newInputValue,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Type of Specimen"
                fullWidth
              />
            )}
          />

          <br />
          <TextField
            select
            label="Lab"
            placeholder="Lab"
            fullWidth
            margin="normal"
            name="lab"
            value={formData.lab}
            onChange={handleChange}
          >
            <MenuItem value="Pathology">Pathology</MenuItem>
            <MenuItem value="Cytology">Cytology</MenuItem>
            <MenuItem value="Microbiology">Microbiology</MenuItem>
            <MenuItem value="Biochemistry">Biochemistry</MenuItem>
          </TextField>
          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" gutterBottom>
            Frozen Section
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Time sent"
                fullWidth
                type="time"
                name="frozen_section_time_sent"
                value={formData.frozen_section_time_sent}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Time of Report Received"
                fullWidth
                type="time"
                name="frozen_section_time_received"
                value={formData.frozen_section_time_received}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
            </Grid>
          </Grid>
          <TextField
            label="Name of Pathologist: "
            fullWidth
            name="name_of_pathologist"
            value={formData.name_of_pathologist}
            onChange={handleChange}
            sx={{ mb: 2 }}
          />
          <br />
          <Autocomplete
            freeSolo
            options={transferDestinations}
            value={formData.transferred_to_recovery_icu}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "transferred_to_recovery_icu",
                  value: newValue || "",
                },
              });
            }}
            onInputChange={(event, newInputValue) => {
              handleChange({
                target: {
                  name: "transferred_to_recovery_icu",
                  value: newInputValue,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Transferred to Recovery/ICU"
                fullWidth
                sx={{ mb: 2 }}
              />
            )}
          />

          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" sx={{ marginTop: 3 }}>
            Signatures
          </Typography>
          <Grid container spacing={2}>
            {[
              {
                label: "Scrub Nurse",
                key: "scrub_nurse_signature",
                key1: "scrub_nurse_name",
                key2: "scrub_nurse_datetime",
              },
              {
                label: "Witness",
                key: "circulating_nurse_signature",
                key1: "circulating_nurse_name",
                key2: "circulating_nurse_datetime",
              },
            ].map((person, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <TextField
                  name={person.key1}
                  value={formData[person.key1]}
                  fullWidth
                  label={`Name (${person.label})`}
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                  onChange={handleChange}
                />
                <TextField
                  name={person.key2}
                  value={formData[person.key2]}
                  fullWidth
                  label={`Signature (${person.label})`}
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                  inputProps={{ min: new Date().toISOString().slice(0, 16), }}
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{ marginTop: 2 }}
                  onClick={() => handleSignatureOpen(person.key)}
                >
                  Sign Here
                </Button>
                {formData[person.key] && (
                  <img
                    src={`data:image/png;base64,${formData[person.key]}`}
                    alt="Signature"
                    style={{
                      marginTop: 10,
                      border: "1px solid black",
                      width: "100%",
                      height: "150px",
                    }}
                  />
                )}
              </Grid>
            ))}
          </Grid>

          <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
            <DialogTitle>Provide Your Signature</DialogTitle>
            <DialogContent>
              <SignatureCanvas
                ref={signaturePadRef}
                canvasProps={{ width: 400, height: 200, className: "sigCanvas" }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose} >close</Button>
              <Button onClick={handleSignatureClear} color="secondary">
                Clear
              </Button>
              <Button onClick={handleSignatureSave} color="0, 128, 128">
                Done
              </Button>

            </DialogActions>
          </Dialog>

          <Divider sx={{ my: 2 }} />
          <Typography textAlign={"center"}>Name of the Implant</Typography>
          <Divider sx={{ my: 2 }} />
          <Autocomplete
            freeSolo
            options={implantNameSuggestions}
            value={formData.name_of_implant}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "name_of_implant",
                  value: newValue || "",
                },
              });
            }}
            onInputChange={(event, newInputValue) => {
              handleChange({
                target: {
                  name: "name_of_implant",
                  value: newInputValue,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                multiline
                rows={5}
                variant="outlined"
                fullWidth
                label="Name of the Implant"
              />
            )}
          />
          <Grid sx={12}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <DraftSaveButton
                formKey={DRAFT_KEYS.INTRAOPERATIVE_NURSING_RECORD}
                uhidNo={uhid_no}
                formData={formData}
                onDraftLoaded={(draftData) => setFormData(prev => ({ ...prev, ...draftData }))}
                variant="outlined"
                size="large"
                isUpdate={success === "success"}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ marginTop: 3 }}
                fullWidth
                onClick={handlesubmit}
              >
                {success === "success" ? 'Update ' : 'Submit'}
              </Button>
            </Box></Grid>



        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default Operative;